import { styled } from '@mui/system'
import { Switch, FormControlLabel } from '@mui/material'
import { FC } from 'react'

const StyledPanel = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}))

// Define types for color and size
type SwitchColor = 'primary' | 'success' | 'error' | 'warning'
type SwitchSize = 'small' | 'medium'

interface SwitchConfig {
  color: SwitchColor
  size: SwitchSize
  label: string
}

// Configuration for different switches
const switchConfigurations: SwitchConfig[] = [
  { color: 'primary', size: 'small', label: 'Primary Small' },
  { color: 'primary', size: 'medium', label: 'Primary Medium' },
  { color: 'success', size: 'small', label: 'Success Small' },
  { color: 'success', size: 'medium', label: 'Success Medium' },
  { color: 'error', size: 'small', label: 'Error Small' },
  { color: 'error', size: 'medium', label: 'Error Medium' },
  { color: 'warning', size: 'small', label: 'Warning Small' },
  { color: 'warning', size: 'medium', label: 'Warning Medium' },
]

const SwitchPanel: FC = () => {
  return (
    <StyledPanel>
      {switchConfigurations.map((config, index) => (
        <FormControlLabel
          key={index}
          control={<Switch color={config.color} size={config.size} defaultChecked={true} />}
          label={config.label}
        />
      ))}
    </StyledPanel>
  )
}

export default SwitchPanel
